export enum RefundsEvents {
  RefundClick = 'refund_click',
  RefundDownload = 'refund_download',
}
